export const SET_TEACHER_NAV = 'SET_TEACHER_NAV'
export const UNSET_TEACHER_NAV = 'UNSET_TEACHER_NAV'
export const SET_TEACHER_NAV_CURRENT = 'SET_TEACHER_NAV_CURRENT'
